import React from 'react';
import util from 'Utils/commonUtil';
import PropTypes from 'prop-types';

// Components
import Anchor from 'Components/common/Anchor';
import BasicButton from 'Components/common/BasicButton';
import SimpleMenu from 'Components/common/SimpleMenu';
import {base64ShippingImage} from 'Utils/constant';

// Actions
import {T} from 'Actions/translate';
import {loadLanguage} from 'Utils/jwtUtil';
import {Grid} from '@material-ui/core';
// Icons
import {Timer} from '@material-ui/icons';

class ShipmentItem extends React.Component {
    chineseNumberList = [
        ['一', '二', '三', '四', '五', '六', '七', '八', '九'],
        ['十', '二十', '三十', '四十', '五十', '六十', '七十', '八十', '九十'],
        [
            '一百',
            '两百',
            '三百',
            '四百',
            '五百',
            '六百',
            '七百',
            '八百',
            '九百',
        ],
    ];

    state = {
        isEllipsis: false,
    };

    componentDidMount() {
        let comments = this.refs['comments-text'];

        if (comments && comments.offsetHeight < comments.scrollHeight) {
            this.setState({isEllipsis: true});
        }
    }

    isSelfPickup = (shippingType) =>
        shippingType === 1 ? (
            <span className="is-self-pickup">
                {T('shippment_self_pick_up')}
            </span>
        ) : null;

    getReceiveQuantity = () => {
        const {item} = this.props;
        let countReceiveQuantity = 0;

        item.shipments &&
            item.shipments.forEach((item) => {
                if (item.status === 4) countReceiveQuantity++;
            });

        return countReceiveQuantity
            ? T('have_been_signed') +
                  `${countReceiveQuantity}` +
                  T('notification_others_have_been_cancelled')
            : '';
    };

    getSKUNumbers = (products, isShipment) => {
        let skuNumberList = [];

        products &&
            products.forEach((item) => {
                skuNumberList.push(
                    item.sku || (item.product && item.product.sku),
                );
            });

        return skuNumberList.filter(Boolean).join(', ');
    };

    getChineseNumber(num) {
        let arr = ('' + num).split('').reverse();
        let str = '';

        if (num >= 1000) return num;

        arr.forEach((num, index) => {
            if (this.chineseNumberList[index][num - 1])
                str = this.chineseNumberList[index][num - 1] + str;
        });

        return str;
    }

    getStatusDesc = (item) => {
        if (item.status === 1 && !item.partialDelivery) {
            return T('pending_orders');
        }
        if (item.status === 1 && item.partialDelivery) {
            return T('Shipped_order') + '-' + T('part_of_the_shipment');
        }
        if (item.status === 2 && !item.partialDelivery) {
            return T('no_delivery_order');
        }
        if (item.status === 2 && item.partialDelivery) {
            return T('no_delivery_order') + '-' + T('part_of_the_shipment');
        }
        if (item.status === 3) {
            return T('Shipped_order') + '-' + T('all_shipments');
        }
        if (item.status === 4) {
            return T('signed_for_order');
        }
        if (item.status === -1 && this.getReceiveQuantity()) {
            return (
                T('signed_for_order') +
                '-' +
                T('Part_of_sign_after_receiving_STH')
            );
        }
        if (item.status === -1 && !this.getReceiveQuantity()) {
            return T('cancelled_order');
        }
    };

    getProductsQuantity(products, isShipment) {
        let quantity = 0;

        products &&
            products.forEach((p) => {
                quantity += p.quantity;
            });

        return quantity;
    }

    stopBubble = (e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.e.cancelBubble = true;
        }
    };

    phoneClick = (e) => {
        e.stopPropagation();
    };

    isDisplayTagFlag = (item, status, isOrder) => {
        let isDisplayTagFlag = false;
        if (
            item.partialDelivery ||
            (item.partialDelivery === false && !isOrder) ||
            status === -1 ||
            status === 4 ||
            (this.getReceiveQuantity() && status === -1) ||
            util.getLockedType(item) === 'checking' ||
            util.getLockedType(item) === 'financialLocked' ||
            util.getLockedType(item) === 'addingC2Locked'
        ) {
            isDisplayTagFlag = true;
        }
        return isDisplayTagFlag;
    };

    phoneClick = (e) => {
        e.stopPropagation();
    };

    viewSpecialTags = (item, e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.e.cancelBubble = true;
        }
        this.props.viewSpecialTagsHandle(item);
    };

    showShipmentTitle = (item, options, status, isOrder) => {
        return options.showTag ? (
            item.haveShippingPlan ? (
                <div className="shipment-have-shipping-plan">
                    <Timer />
                    <h3
                        className="item-title"
                        style={{
                            paddingLeft: item.shippingType === 1 ? '3.2rem' : 0,
                            paddingRight: this.isDisplayTagFlag(
                                item,
                                status,
                                isOrder,
                            )
                                ? '4rem'
                                : 0,
                        }}>
                        {this.isSelfPickup(item.shippingType)}
                        {item.labOrDept}

                        {util.getPropertyExistsAndIsTrue(
                            item.showSpecialTagsFlag,
                        ) ? (
                            <img
                                className="special-tags-icon"
                                alt=""
                                src={
                                    new URL(
                                        'Images/specialTags.png',
                                        import.meta.url,
                                    ).href
                                }
                                onClick={(event) =>
                                    this.viewSpecialTags(item, event)
                                }
                                onTouchStart={this.phoneClick}
                                title={T('shipment_list_special_tags')}
                            />
                        ) : null}
                    </h3>
                </div>
            ) : (
                <h3
                    className="item-title"
                    style={{
                        paddingLeft: item.shippingType === 1 ? '3.2rem' : 0,
                        paddingRight: this.isDisplayTagFlag(
                            item,
                            status,
                            isOrder,
                        )
                            ? '4rem'
                            : 0,
                    }}>
                    {this.isSelfPickup(item.shippingType)}
                    {item.labOrDept}

                    {util.getPropertyExistsAndIsTrue(
                        item.showSpecialTagsFlag,
                    ) ? (
                        <img
                            className="special-tags-icon"
                            alt=""
                            src={
                                new URL(
                                    'Images/specialTags.png',
                                    import.meta.url,
                                ).href
                            }
                            onClick={(event) =>
                                this.viewSpecialTags(item, event)
                            }
                            onTouchStart={this.phoneClick}
                            title={T('shipment_list_special_tags')}
                        />
                    ) : null}
                </h3>
            )
        ) : item.haveShippingPlan ? (
            <div className="shipment-have-shipping-plan">
                <Timer />
                <h3 className="item-title text-ellipsis is-status">
                    {this.getStatusDesc(item)}

                    {util.getPropertyExistsAndIsTrue(
                        item.showSpecialTagsFlag,
                    ) ? (
                        <img
                            className="special-tags-icon"
                            alt=""
                            src={
                                new URL(
                                    'Images/specialTags.png',
                                    import.meta.url,
                                ).href
                            }
                            onClick={(event) =>
                                this.viewSpecialTags(item, event)
                            }
                            onTouchStart={this.phoneClick}
                            title={T('shipment_list_special_tags')}
                        />
                    ) : null}
                </h3>
            </div>
        ) : (
            <h3 className="item-title text-ellipsis is-status">
                {this.getStatusDesc(item)}

                {util.getPropertyExistsAndIsTrue(item.showSpecialTagsFlag) ? (
                    <img
                        className="special-tags-icon"
                        alt=""
                        src={
                            new URL('Images/specialTags.png', import.meta.url)
                                .href
                        }
                        onClick={(event) => this.viewSpecialTags(item, event)}
                        onTouchStart={this.phoneClick}
                        title={T('shipment_list_special_tags')}
                    />
                ) : null}
            </h3>
        );
    };

    render() {
        const {item, status, isOrder, options, shipFlag, b2bShipmentFlag} =
            this.props;
        let lang = loadLanguage();

        return (
            <li className={this.props.className} id={this.props.anchorId}>
                <Anchor onClickOfSingleTap={this.props.chooseItem}>
                    <div
                        data-order-no={item.orderNo}
                        data-sku={item.sku}
                        data-quantity={item.quantity}
                        data-shipment-status={status}>
                        {this.showShipmentTitle(item, options, status, isOrder)}
                        <div className="row clearfix">
                            <div className="ship-to-name text-ellipsis pull-left">
                                <label>{T('shippment_receiver')}</label>
                                {item.receiver}
                            </div>
                            <div className="ship-to-tel text-ellipsis pull-left">
                                <label>{T('shippment_contact')}</label>
                                <a
                                    className="shipment-list-shippment_contact"
                                    href={`tel:${item.receiverTel}`}
                                    onTouchStart={this.phoneClick}
                                    onClick={this.stopBubble}>
                                    {item.receiverTel}
                                </a>
                            </div>
                        </div>

                        {item.expectShipDate ? (
                            <div className="buy-time row">
                                <label>{T('shippment_expect_ship_date')}</label>
                                <p>{item.expectShipDate}</p>
                            </div>
                        ) : null}

                        {options.showBuyTime ? (
                            <div className="buy-time row">
                                <label>{T('shippment_purchase_date')}</label>
                                <p>{item.createTime}</p>
                            </div>
                        ) : null}
                        {options.showShipTime ? (
                            <div className="ship-time row">
                                <label>{T('shippment_delivery_date')}</label>
                                <p>
                                    {item.shipments &&
                                        item.shipments[0] &&
                                        item.shipments[0].createTime}
                                </p>
                            </div>
                        ) : null}
                        {options.showReceivedTime ? (
                            <div className="ship-time row">
                                <label>{T('shippment_sign_date')}</label>
                                <p testid="shipment-received-at">
                                    {item.receivedTime}
                                </p>
                            </div>
                        ) : null}
                        {options.showCancelTime ? (
                            <div className="cancel-time row">
                                <label>{T('shippment_cancel_date')}</label>
                                <p>{item.cancelTime}</p>
                            </div>
                        ) : null}
                        {options.showComments ? (
                            <div className="commonts row">
                                <label>{T('shippment_remark')}</label>
                                <p
                                    ref="comments-text"
                                    className={util.getClassName({
                                        ellipsis: this.state.isEllipsis,
                                    })}>
                                    {item.remark}
                                </p>
                            </div>
                        ) : null}
                        {options.showNumber ? (
                            <div
                                className={
                                    status === 1 || item.status === 2
                                        ? 'row text-ellipsis add-shipping-image'
                                        : 'row text-ellipsis'
                                }>
                                <div>
                                    <label>{T('shippment_order_number')}</label>
                                    <span>{item.number}</span>
                                </div>
                                {(status === 1 || status === 2) &&
                                b2bShipmentFlag === 'Y' ? (
                                    <div
                                        onClick={
                                            this.props
                                                .viewB2bCasmartMessageHandle
                                        }
                                        onTouchStart={this.phoneClick}>
                                        <img
                                            src={base64ShippingImage}
                                            alt="Base64 Image"
                                        />
                                    </div>
                                ) : null}
                            </div>
                        ) : null}
                        {options.showNumber ? (
                            <div className="row text-ellipsis">
                                <Grid className="eone-number-container">
                                    <label>
                                        {T('shippment_eone_number_hyphen')}
                                    </label>
                                    <span>{item.eoneNumber}</span>
                                </Grid>
                                {item.actualTransportMethod ? (
                                    <Grid className="delivery-method-container">
                                        {/* <label>
                                        {T('order_delivery_method')}:
                                    </label> */}
                                        <span>
                                            {T('(')}
                                            {item.actualTransportMethod ===
                                            'Direct'
                                                ? T('direct_method')
                                                : item.actualTransportMethod ===
                                                  'N'
                                                ? T('order_no_name')
                                                : T('mail_method')}
                                            {T(')')}
                                        </span>
                                    </Grid>
                                ) : null}
                            </div>
                        ) : null}
                        {/* {options.showNumber ? (
                            <div className="row text-ellipsis">
                                <label>{T('shippment_eone_status')}</label>
                                <span>{T(item.eoneStatus)}</span>
                            </div>
                        ) : null} */}
                        {status === 3 && item.shipments[0].expressNumber ? (
                            <div className="row text-ellipsis">
                                <label>
                                    {T('shippment_details_shipment_number')}
                                </label>
                                <span>
                                    {T(item.shipments[0].expressNumber)}
                                </span>
                            </div>
                        ) : null}
                        {options.showSkuList ? (
                            item.shipments &&
                            item.shipments[0] &&
                            util.isBoolean(item.shipments[0].shipAllInOne) &&
                            (item.shipments[0].shipAllInOne === false ||
                                item.partialDelivery === true) ? (
                                <div>
                                    <div className="shipment-number row">
                                        <p>
                                            <span className="ship-batch-num">
                                                {T('shippment_all_order')}
                                            </span>{' '}
                                            {this.getSKUNumbers(
                                                item.orderProducts,
                                            )}
                                        </p>
                                        <span className="number">
                                            {T('shippment_total_pieces', [
                                                this.getProductsQuantity(
                                                    item.orderProducts,
                                                ),
                                            ])}
                                        </span>
                                    </div>
                                    <div className="shipment-number row">
                                        <p>
                                            <span className="ship-batch-num">
                                                {T('shippment_serveral_times', [
                                                    this.getChineseNumber(
                                                        item.shipments &&
                                                            item.shipments[0] &&
                                                            item.shipments[0]
                                                                .shipBatchNum,
                                                    ),
                                                ])}
                                            </span>{' '}
                                            {this.getSKUNumbers(
                                                item.shipments[0]
                                                    .shipmentProducts,
                                                true,
                                            )}
                                        </p>
                                        <span className="number">
                                            {T('shippment_total_pieces', [
                                                this.getProductsQuantity(
                                                    item.shipments.length &&
                                                        item.shipments[0] &&
                                                        item.shipments[0]
                                                            .shipmentProducts,
                                                    true,
                                                ),
                                            ])}
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <div className="shipment-number row space-between align-items-center">
                                    <p>
                                        {this.getSKUNumbers(item.orderProducts)}
                                    </p>
                                    <span className="number">
                                        {T('shippment_total_pieces', [
                                            this.getProductsQuantity(
                                                item.orderProducts,
                                            ),
                                        ])}
                                    </span>
                                </div>
                            )
                        ) : null}
                        <div
                            className={util.getClassName({
                                'row buttons': true && lang !== 'EN',
                                'row en-buttons': true && lang === 'EN',
                            })}>
                            {/* <BasicButton
                                type="primary"
                                className="more-infor"
                                onClickOfSingleTap={this.props.openMoreHandle}
                                isStopPropagation={true}>
                                {T('shipment_preview_more')}
                            </BasicButton> */}
                            {status === 1 ? (
                                <SimpleMenu
                                    className="simple-more"
                                    firstRowHandle={this.props.deliverInfor}
                                    secondRowHandle={this.props.notShip}
                                    orderStatus={status}></SimpleMenu>
                            ) : null}
                            {status === 2 ? (
                                <SimpleMenu
                                    className="simple-more"
                                    firstRowHandle={this.props.deliverInfor}
                                    thirdRowHandle={this.props.waitSendGoods}
                                    orderStatus={status}></SimpleMenu>
                            ) : null}
                            {status === 3 ? (
                                <SimpleMenu
                                    className="simple-more"
                                    firstRowHandle={this.props.addTrackNumber}
                                    secondRowHandle={
                                        this.props.shipmentDocumentCoaHandle
                                    }
                                    thirdRowHandle={this.props.customerFeedback}
                                    firstRowLabel={
                                        'shippment_add_tracking_number'
                                    }
                                    secondRowLabel={'shippment_query_coa'}
                                    thirdRowLabel={
                                        'shippment_customer_feedback'
                                    }
                                    orderStatus={status}></SimpleMenu>
                            ) : null}
                            <div className="shipment-button-collection">
                                {status === 3 &&
                                typeof item.showOrderRelatedTask !==
                                    'undefined' &&
                                item.showOrderRelatedTask ? (
                                    <BasicButton
                                        type="primary"
                                        className="order-related-btn"
                                        onClickOfSingleTap={
                                            this.props.goToTaskDetailsHandle
                                        }
                                        isStopPropagation={true}>
                                        {T('shippment_accompany_goods')}
                                    </BasicButton>
                                ) : null}
                                {status === 1 || status === 2 ? (
                                    <BasicButton
                                        type="primary"
                                        className={
                                            'pick-order-infor' +
                                            (util.getLockedType(item) ===
                                                'checking' ||
                                            util.getLockedType(item) ===
                                                'financialLocked' ||
                                            shipFlag === 3 ||
                                            item.isPicking
                                                ? ' shippment-disabled-btn'
                                                : '')
                                        }
                                        onClickOfSingleTap={
                                            this.props.previewPickOrderHandle
                                        }
                                        isStopPropagation={true}
                                        disabled={
                                            util.getLockedType(item) ===
                                                'checking' ||
                                            util.getLockedType(item) ===
                                                'financialLocked' ||
                                            shipFlag === 3 ||
                                            item.isPicking
                                                ? true
                                                : false
                                        }>
                                        {T('shipment_preview_pick_order')}
                                    </BasicButton>
                                ) : null}
                                {status === -1 || status === 4 ? (
                                    <BasicButton
                                        type="primary"
                                        className="customer-feedback-btn"
                                        onClickOfSingleTap={
                                            this.props.customerFeedback
                                        }
                                        isStopPropagation={true}>
                                        {T('shippment_customer_feedback')}
                                    </BasicButton>
                                ) : null}
                                {status === 4 || status === -1 ? (
                                    <BasicButton
                                        type="primary"
                                        className="delivery-infor"
                                        onClickOfSingleTap={
                                            this.props.deliverInfor
                                        }
                                        isStopPropagation={true}>
                                        {T('shippment_delivery_details')}
                                    </BasicButton>
                                ) : null}
                                <BasicButton
                                    type="primary"
                                    onClickOfSingleTap={this.props.recommendPdf}
                                    className="recommended-btn"
                                    isStopPropagation={true}>
                                    {T('shippment_recommended_list')}
                                </BasicButton>
                                {status === 3 && item.punchEnabled === 'Y' ? (
                                    <BasicButton
                                        type="primary"
                                        className={
                                            item.hasPunched === 'Y'
                                                ? 'has-punch-btn'
                                                : 'punch-btn'
                                        }
                                        testid="shipment-checkin-btn"
                                        onClickOfSingleTap={
                                            this.props.shipmentPunchHandle
                                        }
                                        isStopPropagation={true}>
                                        {T('shippment_punch')}
                                    </BasicButton>
                                ) : null}
                                {status === 3 && b2bShipmentFlag === 'Y' ? (
                                    <BasicButton
                                        type="primary"
                                        className={'b2b-casmart-shipment-btn'}
                                        onClickOfSingleTap={
                                            this.props.b2bCasmartShipmentHandle
                                        }
                                        isStopPropagation={true}>
                                        <img
                                            src={base64ShippingImage}
                                            alt="Base64 Image"
                                        />
                                        {T('shippment_b2b_casmart_btn')}
                                    </BasicButton>
                                ) : null}
                                {/* {status === 2 ? (
                                    <BasicButton
                                        type="danger"
                                        onClickOfSingleTap={
                                            this.props.waitSendGoods
                                        }
                                        isStopPropagation={true}>
                                        {T('to_send_the_goods')}
                                    </BasicButton>
                                ) : null} */}
                                {/* {status === 1 ? (
                                    <BasicButton
                                        type="danger"
                                        onClickOfSingleTap={this.props.notShip}
                                        isStopPropagation={true}>
                                        {T('temporary_not')}
                                    </BasicButton>
                                ) : null} */}
                                {status === 1 || status === 2 ? (
                                    <BasicButton
                                        type=""
                                        testid={
                                            shipFlag === 1
                                                ? 'all-shipment-flag'
                                                : shipFlag === 2
                                                ? 'partial-shipment-flag'
                                                : 'not-shipment-flag'
                                        }
                                        className={
                                            (shipFlag === 1
                                                ? 'all-shippment-btn'
                                                : shipFlag === 2
                                                ? 'partial-shippment-btn'
                                                : 'not-shippment-btn') +
                                            (util.getLockedType(item) ===
                                                'checking' ||
                                            util.getLockedType(item) ===
                                                'financialLocked' ||
                                            shipFlag === 3
                                                ? ' shippment-disabled-btn'
                                                : '')
                                        }
                                        onClickOfSingleTap={this.props.ship}
                                        isStopPropagation={true}
                                        disabled={
                                            util.getLockedType(item) ===
                                                'checking' ||
                                            util.getLockedType(item) ===
                                                'financialLocked' ||
                                            shipFlag === 3
                                                ? true
                                                : false
                                        }>
                                        {shipFlag === 1
                                            ? T('shippment_all_available')
                                            : shipFlag === 2
                                            ? T('shippment_partial_shipping')
                                            : T('shippment_not_shipping')}
                                    </BasicButton>
                                ) : null}
                                {status === 3 ? (
                                    <BasicButton
                                        type="primary"
                                        className="shipment-receive"
                                        testid="shipment-receive-btn"
                                        onClickOfSingleTap={this.props.receive}
                                        isStopPropagation={true}>
                                        {T('shippment_take_goods')}
                                    </BasicButton>
                                ) : null}
                            </div>
                        </div>
                        {options.showReceiveQuantity &&
                        this.getReceiveQuantity() &&
                        item.status === -1 ? (
                            <p className="receive-quantity row">
                                {this.getReceiveQuantity()}
                            </p>
                        ) : null}
                        {options.showTag ? (
                            <div
                                testid={`shipment-list-tag-${util.getLockedType(
                                    item,
                                )}`}
                                className={util.getClassName({
                                    tag: true,
                                    'part-shipped':
                                        item.partialDelivery && lang !== 'EN',
                                    'all-shipped':
                                        item.partialDelivery === false &&
                                        !isOrder &&
                                        lang !== 'EN',
                                    'is-cancel': status === -1 && lang !== 'EN',
                                    'is-received':
                                        status === 4 && lang !== 'EN',
                                    'is-part-received':
                                        this.getReceiveQuantity() &&
                                        status === -1 &&
                                        lang !== 'EN',
                                    checking:
                                        util.getLockedType(item) ===
                                            'checking' && lang !== 'EN',
                                    'is-lock':
                                        util.getLockedType(item) ===
                                            'financialLocked' && lang !== 'EN',
                                    'is-adding-c2-lock':
                                        util.getLockedType(item) ===
                                            'addingC2Locked' && lang !== 'EN',
                                    'en-part-shipped':
                                        item.partialDelivery && lang === 'EN',
                                    'en-all-shipped':
                                        item.partialDelivery === false &&
                                        !isOrder &&
                                        lang === 'EN',
                                    'en-is-cancel':
                                        status === -1 && lang === 'EN',
                                    'en-is-received':
                                        status === 4 && lang === 'EN',
                                    'en-is-part-received':
                                        this.getReceiveQuantity() &&
                                        status === -1 &&
                                        lang === 'EN',
                                    'en-checking':
                                        util.getLockedType(item) ===
                                            'checking' && lang === 'EN',
                                    'en-is-lock':
                                        util.getLockedType(item) ===
                                            'financialLocked' && lang === 'EN',
                                    'en-is-adding-c2-lock':
                                        util.getLockedType(item) ===
                                            'addingC2Locked' && lang === 'EN',
                                })}></div>
                        ) : null}
                    </div>
                </Anchor>
            </li>
        );
    }
}

ShipmentItem.propTypes = {
    options: PropTypes.object,
};

ShipmentItem.defaultProps = {
    options: {},
};

export default ShipmentItem;
